// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__3bsF-","root":"styles_root__3cA2G","identifier":"styles_identifier__3TSNE"};